import { useState, useCallback } from 'react';

import { WorkflowSteps } from '../../../../../../tracking/use-workflow-tracking';

const STEP_ID = 'fulfillment_capabilities';

/**
 * Hook for managing fulfillment capabilities step state and logic
 * @param {(step: string, metadata?: object) => void} trackWorkflow
 * @returns {{
 *   fulfillmentCapabilities: object,
 *   isComplete: boolean,
 *   isEditing: boolean,
 *   handleCapabilityChange: (capability: string, checked: boolean) => void,
 *   onContinue: () => void,
 *   onEdit: () => void
 * }}
 */
export const useFulfillmentCapabilitiesStep = (trackWorkflow) => {
  const [fulfillmentCapabilities, setFulfillmentCapabilities] = useState({
    specialKittingBundling: false,
    serialNumberSupport: false,
    hazardousGoods: false,
    coldStorage: false,
    lotsExpirationDates: false,
    heavyItems: false,
    fragileItems: false,
    largeItems: false,
    moreDetails: '',
  });

  const [isComplete, setIsComplete] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleCapabilityChange = useCallback((capability, checked) => {
    setFulfillmentCapabilities((prev) => ({
      ...prev,
      [capability]: checked,
    }));
  }, []);

  const onContinue = useCallback(() => {
    setIsComplete(true);
    setIsEditing(false);
    trackWorkflow(WorkflowSteps.CONTINUE, { stepId: STEP_ID });
  }, [trackWorkflow]);

  const onEdit = useCallback(() => {
    setIsEditing(true);
  }, []);

  return {
    fulfillmentCapabilities,
    isComplete,
    isEditing,
    handleCapabilityChange,
    onContinue,
    onEdit,
  };
};
